module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/send-icon.dd51d806.svg";